import { i18n } from '@/plugins/i18n'


export default [
    {
        field: 'id',
        width: 60,
        title: i18n.t('label.identifier'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'account_number',
        width: 110,
        title: i18n.t('accounting.label.account_number'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'amount',
        width: 110,
        title: i18n.t('label.amount'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'bank_ref_code',
        width: 150,
        title: i18n.t('label.bank_ref_code'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'recorded_at',
        title: i18n.t('accounting.deposit_date'),
        sortable: false,
        textAlign: 'center',
    },
]